import Request from '@/plugins/request';

export function getFeedBack(params) {
  return Request.get('feed-backs', { params })
}

export function createFeedBack() {
  return Request.get(`feed-backs/create`)
}

export function storeFeedBack(data) {
  return Request.post('feed-backs', data)
}

export function updateFeedBack(id, data) {
  return Request.put(`feed-backs/${id}`, data)
}

export function editFeedBack(id) {
  return Request.get(`feed-backs/${id}/edit`)
}

export function destroyFeedBack(id) {
  return Request.delete(`feed-backs/${id}`)
}
